import React from 'react'
import StipopImageVideoData from '../../Components/Data/StipopImageVideoData'

const index = props => {
  return <StipopImageVideoData />
}

export default index
